export default __webpack_public_path__ + "static/media/595.bdff54c8.png";